<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Thanks for getting your account set up" />
    </template>
    <div class="py-4">
      <p>
        This process should be quick and easy taking no longer than 5 minutes,
        assuming no issues with the identificiation checks we are required to complete.
        As part of this process we will be taking you through the following steps:
      </p>
      <ul>
        <li>initial deposit details;</li>
        <li>setting up your payment account;</li>
        <li>setting up your account for withdrawals; and</li>
        <li>completing our required KYC and anti-money laundering checks;</li>
      </ul>
      <p>
        We do this digitally where possible but may require additional documents from you if our digital checks fail.
      </p>
    </div>
    <template v-slot:bottom>
      <div class="bg-light py-4">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-sm-6">
              Estimated time to complete: <strong>5 minutes</strong>
            </div>
            <div class="col-sm-6 text-right">
              <base-button icon-right="arrow-right" :loading="saving" primary @click="save">
                Lets go
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-content>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  data: () => ({
    saving: false
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapGetters({
      schema: 'core/accounts/schema'
    }),

    ...mapState({
      account: store => store.core.accounts.entity
    })
  },

  methods: {
    async save () {
      this.saving = true

      const accounts = this.$auth.user.accounts || []
      const account = this.schema
      account.user = this.$auth.user._id

      await this.$store.dispatch('core/accounts/create', account)
      await this.$store.dispatch('core/auth/patch', {
        accounts: this.$_.map(accounts, '_id').concat(this.account._id)
      })

      this.$router.push({ name: 'account.deposit',
        params: {
          id: this.account._id
        } })
    }
  }
}
</script>
